export const gray = '#424242';
export const cyan = '#4FBCDC';
export const ligthCyan = '#EEFBFF';
export const white = '#FFFFFF';
export const yellow = '#FFD93E';
